import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/icon/paper.png'


const _hoisted_1 = { id: "list-delivery-item" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-2 lg:gap-6 md:gap-6" }
const _hoisted_3 = { class: "container-text" }
const _hoisted_4 = { class: "font-title" }
const _hoisted_5 = { class: "font-subTitle" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: " flex lg:flex-row flex-col items-center sm:items-start justify-between" }, [
  /*#__PURE__*/_createVNode("div", { class: " flex flex-row items-center sm:justify-start md:w-auto  w-full" }, [
    /*#__PURE__*/_createVNode("img", {
      alt: " ",
      src: _imports_0,
      class: " lg:h-12 md:w-12 h-8 w-8"
    }),
    /*#__PURE__*/_createVNode("p", { class: " font-bold text-white  lg:text-xl md:text-xl text-sm  mb-1" }, "Print Resi yang terakhir diproses")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "flex  items-center md:w-auto w-full md:pt-2 pt-4" }, [
    /*#__PURE__*/_createVNode("button", {
      class: " flex flex-col items-center p-button btn-eee p-component p-button p-button-sm rounded-lg  py-1 px-2 md:w-auto  w-full",
      type: "button"
    }, [
      /*#__PURE__*/_createVNode("div", null, [
        /*#__PURE__*/_createVNode("i", { class: "pi pi-print text-primary-dark-2 font-medium mr-2" }),
        /*#__PURE__*/_createVNode("span", { class: "text-primary-dark-2 font-bold lg:text-base md:text-sm text-sm" }, "Print Resi ")
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cardOption, (data, idx) => {
        return (_openBlock(), _createBlock("div", {
          class: "card-delivery cursor-pointer",
          key: idx,
          onClick: ($event: any) => (_ctx.hasAccess(data)),
          style: `background-image: url('${data.assets}')`
        }, [
          _createVNode("div", _hoisted_3, [
            _createVNode("p", _hoisted_4, _toDisplayString(data.title), 1),
            _createVNode("p", _hoisted_5, _toDisplayString(data.subTitle), 1)
          ])
        ], 12, ["onClick"]))
      }), 128)),
      (_ctx.lastReceiptId)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: " background-primary p-4 relative mt-4 rounded-md shadow cursor-pointer col-span-2 ",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openLastReceipt && _ctx.openLastReceipt(...args)))
          }, [
            _hoisted_6
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}